// Granular Refresh spec §5.1. Live per-field drift detection — computed at
// render time, never stored as a flag. A row "drifts" on a field when its
// snapshot value differs from the Campaign's CURRENT value (covers both AM
// overrides and Campaign-side edits since the row snapshotted).
//
// Pure: no rowType gating here. Callers that drive the modification badge
// (hasRowModifications) keep their own opt-out / unassigned bypass — this
// function is a straight field comparator over the manifest so the bulk
// modal's conflict warning and the badge share ONE implementation.
//
// Returns EVERY drifted manifest key, including the two comparison-only
// Overview URLs, so diffCampaignVsRow can delegate here with zero badge
// behaviour change (Granular Refresh commit 9).

import type { AccountCampaign } from '../types/accountCampaign.js';
import type { Campaign } from '../types/campaign.js';
import {
  REFRESHABLE_FIELDS,
  type RefreshableFieldKey,
} from './refreshableFields.js';

export function getDriftedFields(
  row: AccountCampaign,
  campaign: Campaign,
): RefreshableFieldKey[] {
  const drifted: RefreshableFieldKey[] = [];
  for (const entry of REFRESHABLE_FIELDS) {
    if (entry.isModified(row, campaign)) drifted.push(entry.key);
  }
  return drifted;
}

// Convenience: is this row drifted on ANY manifest field? Cheaper-to-read
// call site than `getDriftedFields(...).length > 0` and short-circuits.
export function hasAnyDrift(row: AccountCampaign, campaign: Campaign): boolean {
  return REFRESHABLE_FIELDS.some((e) => e.isModified(row, campaign));
}
